// Utilitaires de formatage de date/heure pour les événements

function formatDateLong(dateStr) {
  if (!dateStr) return "";
  try {
    const d = new Date(dateStr + "T00:00:00");
    return d.toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" });
  } catch {
    return dateStr;
  }
}

function formatDateFull(dateStr) {
  if (!dateStr) return "";
  try {
    const d = new Date(dateStr + "T00:00:00");
    return d.toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
  } catch {
    return dateStr;
  }
}

export function formatDateRange(start, end, { full = false } = {}) {
  const fmt = full ? formatDateFull : formatDateLong;
  if (!end || end === start) return fmt(start);
  // Same year/month: "Du 10 au 12 juin 2026"
  try {
    const s = new Date(start + "T00:00:00");
    const e = new Date(end + "T00:00:00");
    if (s.getFullYear() === e.getFullYear() && s.getMonth() === e.getMonth()) {
      const month = s.toLocaleDateString("fr-FR", { month: "long" });
      return `Du ${s.getDate()} au ${e.getDate()} ${month} ${s.getFullYear()}`;
    }
    return `Du ${fmt(start)} au ${fmt(end)}`;
  } catch {
    return `${start} → ${end}`;
  }
}

export function formatTimeRange(start, end) {
  if (!start) return "";
  if (!end || end === start) return start;
  return `${start} – ${end}`;
}

export function formatDateShort(dateStr) {
  if (!dateStr) return "";
  try {
    const d = new Date(dateStr + "T00:00:00");
    return d.toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch {
    return dateStr;
  }
}

export function formatDateRangeShort(start, end) {
  if (!end || end === start) return formatDateShort(start);
  return `${formatDateShort(start)} → ${formatDateShort(end)}`;
}
